import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["type", "disabled"]




export default /*#__PURE__*/_defineComponent({
  props: {
  type: { type: String, default: "button" },
  disabled: { type: Boolean, default: false },
  variant: {
    type: String,
    default: "primary",
    validator: (value: string) =>
      ["primary", "default", "danger", "soft-primary"].includes(value),
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    type: __props.type,
    disabled: __props.disabled,
    class: _normalizeClass(["btn", {
      'btn-default': __props.variant === 'default',
      'btn-danger': __props.variant === 'danger',
      'btn-primary': __props.variant === 'primary',
      'btn-soft-primary': __props.variant === 'soft-primary',
    }])
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 10, _hoisted_1))
}
}

})